import React, { FC, useEffect } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { Annotation } from 'types'
import { AnnotationDeletionWarningModal } from 'components/AnnotationDeletionWarningModal'
// import { BackButton } from 'components/BackButton/BackButton'
import {
  CompanyIdUrlParam,
  Field as IField,
  ProjectIdUrlParam,
  TemplateIdUrlParam,
} from 'types'
// import { ErrorsDisplay } from 'components/ErrorsDisplay'
import {
  fetchTemplateDocument,
  updateTemplateDocument,
} from 'state/async_actions'
import { Field } from 'models/Field'
// import { NoticesDisplay } from 'components/NoticesDisplay'
import { TemplateDocumentEditor } from '../TemplateDocumentEditor'
import { useAppContext } from 'state/context'
import { useAnnotations } from 'hooks/useAnnotations'
import { useForm } from 'hooks/useForm'
import { useTemplate } from 'hooks/useTemplate'
import { fetchTemplateDirectories } from 'hooks/useDataLoader'
interface InputProps {
  title: string
  file: File
  fieldsAttributes: IField[]
}

export const NoCompanyText = 'No Company found that matches this company'

type UrlParams = TemplateIdUrlParam & CompanyIdUrlParam & ProjectIdUrlParam
export const EditTemplateForm: FC<UrlParams> = ({
  companyId,
  projectId,
  templateDocumentId,
}) => {
  const [, dispatch] = useAppContext()
  const [previousFile, setPreviousFile] = React.useState(null)
  useEffect(() => {
    fetchTemplateDocument(dispatch, templateDocumentId)
  }, [dispatch, templateDocumentId])
  const template = useTemplate(templateDocumentId)
  const templateTitle = template && template.title
  const templateFileUrl = template && template.fileUrl

  const [
    annotations,
    currentAnnotation,
    setAnnotation,
    addAnnotation,
    setPreviousAnnotations,
    updateAnnotation,
    deleteAnnotation,
    undoDeleteAnnotation,
  ] = useAnnotations()

  const [undoDeletion, setUndoDeletion] = React.useState<
    (() => () => void) | undefined
  >()

  const [renderWarning, setRenderWarning] = React.useState<boolean>(false)
  const resetRenderWarning = () => setRenderWarning(false)
  useEffect(() => {
    if (template && template.fields.length > 0) {
      setPreviousAnnotations(template.fields.map(Field.toAnnotation))
    }
  }, [template?.id])

  useEffect(() => {
    if (templateFileUrl) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', templateFileUrl)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        setPreviousFile(xhr.response)
      }
      xhr.send()
    }
  }, [templateFileUrl])

  const [{ title, file }, handleInputChange, handleSubmit, validated] = useForm<
    InputProps
  >(async submittedInputs => {
    const fieldsAttributes = annotations.map(Field.fromAnnotation)

    submittedInputs = {
      ...submittedInputs,
      fieldsAttributes,
      file: file || previousFile,
    }

    await updateTemplateDocument(dispatch, templateDocumentId, submittedInputs)
    fetchTemplateDirectories(dispatch, projectId)
    window.history.go(-1)
    // navigate(`/company/${companyId}/project/${projectId}`)
  })

  const deleteAnnotationAndWarnUser = (annotation: Annotation) => {
    deleteAnnotation(annotation)
    if (annotation.data.hasDocumentsFields) {
      setRenderWarning(true)
      setUndoDeletion(() => () => undoDeleteAnnotation(annotation))
    }
  }

  return template ? (
    <>
      {renderWarning && (
        <AnnotationDeletionWarningModal
          cancelAction={undoDeletion}
          updateParentState={resetRenderWarning}
        />
      )}
      <Row>
        <Col>
          <h1>Edit {templateTitle}</h1>
          {/* <ErrorsDisplay /> */}
          {/* <NoticesDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange}
                value={title || templateTitle || ''}
                name="title"
                type="text"
                placeholder="Enter Title"
              />
              <Form.Control.Feedback type="invalid">
                Please enter a title for your template.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formFile">
              <Form.Label>PDF File</Form.Label>
              <Form.Control
                accept="application/pdf"
                onChange={handleInputChange}
                name="file"
                type="file"
              />
              <Form.Control.Feedback type="invalid">
                Please choose a PDF document from your device.
              </Form.Control.Feedback>
            </Form.Group>
            <Button
              className="btn-icon-plus"
              variant="primary"
              value="Upload new Template"
              type="submit">
              Update Template
            </Button>
            {/* <BackButton /> */}
          </Form>
        </Col>
        <Col>
          {(file || previousFile) && (
            <TemplateDocumentEditor
              currentAnnotation={currentAnnotation || {}}
              annotations={annotations}
              setAnnotation={setAnnotation}
              addAnnotation={addAnnotation}
              updateAnnotation={updateAnnotation}
              deleteAnnotation={deleteAnnotationAndWarnUser}
              file={file || previousFile}
              projectId={projectId}
            />
          )}
        </Col>
      </Row>
    </>
  ) : (
    <>
      {/* <ErrorsDisplay />
      <NoticesDisplay /> */}
      <div>No Template</div>
    </>
  )
}
